export default [
    {
        path: '/pages/housekeeping/servAppraiseManage',
        name: '/pages/housekeeping/servAppraiseManage',
        component: () => import('@/views/housekeeping/servAppraiseManage.vue')
    },
    {
        path: '/pages/housekeeping/resourceStoreTypeManage',
        name: '/pages/housekeeping/resourceStoreTypeManage',
        component: () => import('@/views/housekeeping/resourceStoreTypeManage.vue')
    },
    {
        path: '/pages/housekeeping/housekeepingType',
        name: '/pages/housekeeping/housekeepingType',
        component: () => import('@/views/housekeeping/housekeepingType.vue')
    },
    {
        path: '/pages/housekeeping/housekeepingServUserManage',
        name: '/pages/housekeeping/housekeepingServUserManage',
        component: () => import('@/views/housekeeping/housekeepingServUserManage.vue')
    },
    {
        path: '/pages/housekeeping/housekeepingServPoolUserManage',
        name: '/pages/housekeeping/housekeepingServPoolUserManage',
        component: () => import('@/views/housekeeping/housekeepingServPoolUserManage.vue')
    },
    {
        path: '/pages/housekeeping/housekeepingServPoolPayOrder',
        name: '/pages/housekeeping/housekeepingServPoolPayOrder',
        component: () => import('@/views/housekeeping/housekeepingServPoolPayOrder.vue')
    },
    {
        path: '/pages/housekeeping/housekeepingServPoolPay',
        name: '/pages/housekeeping/housekeepingServPoolPay',
        component: () => import('@/views/housekeeping/housekeepingServPoolPay.vue')
    },
    {
        path: '/pages/housekeeping/housekeepingServPoolManage',
        name: '/pages/housekeeping/housekeepingServPoolManage',
        component: () => import('@/views/housekeeping/housekeepingServPoolManage.vue')
    },
    {
        path: '/pages/housekeeping/housekeepingServFeeConfigManageRel',
        name: '/pages/housekeeping/housekeepingServFeeConfigManageRel',
        component: () => import('@/views/housekeeping/housekeepingServFeeConfigManageRel.vue')
    },
    {
        path: '/pages/housekeeping/housekeepingServDetail',
        name: '/pages/housekeeping/housekeepingServDetail',
        component: () => import('@/views/housekeeping/housekeepingServDetail.vue')
    },
    {
        path: '/pages/housekeeping/housekeepingServ',
        name: '/pages/housekeeping/housekeepingServ',
        component: () => import('@/views/housekeeping/housekeepingServ.vue')
    },
    {
        path: '/pages/housekeeping/housekeepingResourceManage',
        name: '/pages/housekeeping/housekeepingResourceManage',
        component: () => import('@/views/housekeeping/housekeepingResourceManage.vue')
    },
    {
        path: '/pages/housekeeping/housekeepingFeeType',
        name: '/pages/housekeeping/housekeepingFeeType',
        component: () => import('@/views/housekeeping/housekeepingFeeType.vue')
    },
    {
        path: '/pages/housekeeping/housekeepingDispatchManage',
        name: '/pages/housekeeping/housekeepingDispatchManage',
        component: () => import('@/views/housekeeping/housekeepingDispatchManage.vue')
    },
    {
        path: '/pages/housekeeping/housekeepingFeeConfigManage',
        name: '/pages/housekeeping/housekeepingFeeConfigManage',
        component: () => import('@/views/housekeeping/housekeepingFeeConfigManage.vue')
    },
    {
        path: '/pages/housekeeping/editHousekeepingServ',
        name: '/pages/housekeeping/editHousekeepingServ',
        component: () => import('@/views/housekeeping/editHousekeepingServ.vue')
    },
    {
        path: '/pages/housekeeping/addHousekeepingServ',
        name: '/pages/housekeeping/addHousekeepingServ',
        component: () => import('@/views/housekeeping/addHousekeepingServ.vue')
    }
] 